import { useDispatch, useSelector } from "react-redux";
import { setSelectedMessage } from "../../../slice/MessageSlice";
import { useEffect, useState } from "react";

const EachMessage = ({ conversation, selectedConversation }) => {
  const [selectedChatClass, setSelectedChatClass] = useState("");

  /* const { selectedConversation } = useSelector((state) => state.selectedConversation); */

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedConversation && selectedConversation.customer.id === conversation.customer.id) {
      setSelectedChatClass("selecetedMessage");
    } else {
      setSelectedChatClass("");
    }
  }, [selectedConversation]);

  const selectedMessage = (e) => {
   /*  let targetDiv = e.target;
    let targetDivParentChildren = targetDiv.parentElement.children;
    Array.from(targetDivParentChildren).forEach((child) => {
      child.classList.remove("selecetedMessage");
    });
    targetDiv.classList.add("selecetedMessage"); */
    /* setSelecetedMessage(conversation); */
    dispatch(setSelectedMessage(conversation));
  };

  return (
    <>
      <div onClick={(e) => selectedMessage(e)} className={`EachMessageCompDiv` + " "+selectedChatClass}>
        <img src={conversation.customer.profileImage} />
        <div>
          <p>{conversation.customer.fullName} </p>
          <p>{conversation.customer.lastMessage} </p>
        </div>
      </div>
    </>
  );
};

export default EachMessage;
